import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SettingResponse } from 'src/app/models/setting';
import { SettingsService } from '../settings.service';
import * as settingsActions from './settings.actions';

@Injectable({
  providedIn: 'root'
})
export class SettingsEffects {

  constructor(private actions$: Actions,
    private settingsService: SettingsService) { }

  loadSettings$ = createEffect(() => this.actions$.pipe(
    ofType(settingsActions.SettingsActionTypes.Load),
    switchMap(() => this.settingsService.getSettings().pipe(
      map((response: SettingResponse | null | undefined) => {
        // Validate the response shape before letting it into the store.
        // A malformed payload (undefined, null, missing .settings, or a
        // non-array .settings) used to silently poison the store and crash
        // every consumer that did `settings.length` or `.filter(...)`.
        const settings = response?.settings;
        if (!Array.isArray(settings)) {
          return new settingsActions.LoadFail(
            `Settings response is malformed: expected an array, got ${typeof settings}.`);
        }
        return new settingsActions.LoadSuccess(settings);
      }),
      catchError(err => {
        const errMsg = (err && err.statusText) ? err.statusText :
          (err instanceof Error ? err.message : String(err));
        return of(new settingsActions.LoadFail(errMsg));
      })
    ))
  ));
}
